import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";



const GoogleAnalyticsListener = () => {
  const location = useLocation();
  const userData = useSelector((state: any) => state.currentUser.data);
  const currentBrandData = useSelector((state: any) => state.currentBrand.data);
  const userDataIsLoading = useSelector((state: any) => state.currentUser.isLoading);
  const currentBrandIsLoading = useSelector((state: any) => state.currentBrand.isLoading);
  const googleTrackingId = process.env.REACT_APP_GOOGLE_ID as string;

  const doNotTrackUserId = useMemo(() => {
    if (!currentBrandData.domainSettings || currentBrandIsLoading) return false;
    return currentBrandData.domainSettings.doNotTrackUserId;
  }, [currentBrandData, currentBrandIsLoading]);

  const userToken = useMemo(() => {
    if (!userData.user_token || userDataIsLoading) return false;
    return userData.user_token;
  }, [userData, userDataIsLoading]);

  const userIsAdmin = useMemo(() => userData.admin, [userData]);

  const isNotLocalHost = useMemo(
    () => window.location.origin.indexOf("localhost") === -1,
    []
  );

  const getCleanUrl = () => {
    var url = window.location.href;
    var paramsToRemove = ['auth']; 
  
    try {
      var urlObj = new URL(url);
      paramsToRemove.forEach(function(param) {
        urlObj.searchParams.delete(param);
      });
      return urlObj.toString();
    } catch (e) {
      return url;
    }
  }

  // Initialize GA once
  useEffect(() => {
    if (
      !ReactGA.isInitialized &&
      !userDataIsLoading &&
      !userIsAdmin &&
      isNotLocalHost &&
      userToken
    ) {
      const options = doNotTrackUserId ? {} : { user_id: userToken };
      ReactGA.initialize([
        {
          trackingId: googleTrackingId,
          gaOptions: options,
          gtagOptions: { 
            send_page_view: false,
            page_location: getCleanUrl()
          },
        },
      ]);
    }
  }, [
    userData,
    userToken,
    doNotTrackUserId,
    googleTrackingId,
    userDataIsLoading,
    userIsAdmin,
    isNotLocalHost,
  ]);

  // Track pageviews (after title is set)
  useEffect(() => {
    if (ReactGA.isInitialized && !userDataIsLoading && !userIsAdmin && isNotLocalHost) {
      let sent = false;

      
      const sendPageView = () => {
        if (sent) return;
        
        const trySend = () => {        
          // @ts-ignore
          if (typeof window.gtag === "function") {
            sent = true;
            ReactGA.send({
              hitType: "pageview",
              page: location.pathname,
              title: document.title,
              page_location: getCleanUrl()
            });
          } else {
            setTimeout(trySend, 50);
          }
        };

        trySend();
      };

      // reset flag on route change
      document.body.dataset.titleReady = "false";

      const observer = new MutationObserver(() => {
        if (document.body.dataset.titleReady === "true") {
          sendPageView();
          observer.disconnect();
        }
      });

      observer.observe(document.body, { attributes: true, attributeFilter: ["data-title-ready"] });

      return () => {
        observer.disconnect();
      };
    }
  }, [location, userDataIsLoading, userIsAdmin, isNotLocalHost]);

  return null;
};

export default GoogleAnalyticsListener;
